import { useQuery } from '@tanstack/react-query';
import axios from '../../axiosConfig';
import { GET_ORDER_COMMENTS_DATA } from '../queries/GetOrderDetails';

const fetchOrderComments = async ({ queryKey }) => {
  const [, { token, item, setToast}] = queryKey;

  if (!token ) throw new Error('token not available');

  const getCommentsUrl = `/getOrderComments?&orderNumber=${encodeURIComponent(item.esoi)}`;
  try {
    const response = await axios.get(getCommentsUrl, {
        headers: {
        Authorization: token,
        },
    }); 

    return response.data;

  } catch (error) {
    setToast({ showToast: true, message: error.response?.data, type: 'error' });      
  }
};

export const useGetOrderCommentsData = (params ) => {
  return useQuery({
    queryKey: [GET_ORDER_COMMENTS_DATA, params ],
    queryFn: fetchOrderComments,
    enabled: !!params.token,
    retry: false,
  });
};

